var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 2c1.819 0 3.639.684 5.027 2.053C18.143 5.152 19 7.065 19 9.083c0 4.801-4.855 11.248-6.479 12.708A.78.78 0 0 1 12 22a.78.78 0 0 1-.521-.21C9.855 20.33 5 13.884 5 9.083c0-2.019.857-3.931 1.973-5.03A7.14 7.14 0 0 1 12 2m0 2a5.13 5.13 0 0 0-3.624 1.478C7.691 6.153 7 7.53 7 9.083c0 3.354 3.148 8.178 5 10.355 1.852-2.177 5-7.001 5-10.355 0-1.554-.691-2.93-1.376-3.605A5.13 5.13 0 0 0 12 4m0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
})));
export default SvgGemLocation;